import { prop } from 'ramda';

import { projectsAdapter } from '@/adapters';

export const projectsEntitySelector = projectsAdapter.getSelectors<RootState>(prop('projects'));
